/* ============================================================
   VILLAGE CONFECTIONERY — THEME JS
   ============================================================ */

/* ── Hero scroll lock (homepage only, desktop only) ── */
if (window.innerWidth > 900 && document.getElementById('hero')) {
  document.body.style.overflow = 'hidden';
  setTimeout(function() { document.body.style.overflow = ''; }, 2000);
}

/* Nav: chocolate background once user scrolls */
const nav = document.getElementById('nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('solid', window.scrollY > 50);
  }, { passive: true });
}

document.addEventListener('DOMContentLoaded', function() {
  /* Mobile menu */
  const toggle = document.getElementById('nav-toggle');
  const navLinks = document.getElementById('nav-links');

  if (toggle && navLinks) {
    toggle.addEventListener('click', () => {
      const open = navLinks.classList.toggle('open');
      toggle.classList.toggle('open', open);
      toggle.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  /* Scroll reveal */
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    const ro = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          ro.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(el => ro.observe(el));
  }

  /* Salesforce Web-to-Lead form */
  const wtlForm = document.getElementById('wtl-form');
  if (wtlForm) {
    wtlForm.addEventListener('submit', function() {
      const thanks = document.getElementById('wtl-thanks');
      setTimeout(function() {
        wtlForm.style.display = 'none';
        if (thanks) thanks.style.display = 'block';
      }, 300);
    });
  }
});

/* Global function for closing mobile menu from onclick handlers */
function closeMenu() {
  const navLinks = document.getElementById('nav-links');
  const toggle = document.getElementById('nav-toggle');
  if (navLinks) navLinks.classList.remove('open');
  if (toggle) {
    toggle.classList.remove('open');
    toggle.setAttribute('aria-expanded', 'false');
  }
  document.body.style.overflow = '';
}
